import { render, staticRenderFns } from "./DocumentCSV.vue?vue&type=template&id=5020ad02&"
import script from "./DocumentCSV.vue?vue&type=script&lang=js&"
export * from "./DocumentCSV.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCSV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports